// extracted by mini-css-extract-plugin
export var hidden = "_py-1";
export var visible = "_py-0";